// Centralized environment config.
//
// Reads from CRA env vars first (REACT_APP_*), falls back to the previously
// hardcoded prod URL so existing deployments keep working without setting
// the variable. To override (recommended in Vercel):
//   - Production: REACT_APP_API_URL=https://sea-turtle-app-wouf5.ondigitalocean.app
//   - Local dev:  REACT_APP_API_URL=http://localhost:8084
//
// Note: REACT_APP_* vars are baked into the bundle at build time, so changes
// require a rebuild (Vercel does this automatically on env-var update).

const FALLBACK_API_URL = 'https://sea-turtle-app-wouf5.ondigitalocean.app';

// Las API keys de IA viven SOLO en el backend (proxy /api/ai/chat). Nunca
// vuelvas a poner una key de un proveedor de IA aquí: todo lo de este archivo
// queda expuesto en el bundle del navegador. (La key de DeepSeek que estuvo
// hardcodeada aquí debe revocarse en platform.deepseek.com.)
export const environment = {
  production: process.env.NODE_ENV === 'production',
  apiURL: process.env.REACT_APP_API_URL || FALLBACK_API_URL,
};
